import React from "react";
import Grid from "@mui/material/Grid2";
import { ModalBase } from "./ModalBase";
import modalSize from "../../util/modalSizeEnum";
import alertTypeEnum from "../../util/alertTypeEnum";
import { Typography } from "@mui/material";
import { useEffect } from "react";
import ErrorIcon from "@mui/icons-material/Error";

export const ModalCreditRequestFinalise: React.FC<{
	isOpen: boolean;
	hasExistingCredit: boolean;
	isFullyReceived: boolean;
	onRaiseCreditRequest: () => void;
	onCancelCreditRequest: () => void;
}> = ({ isOpen, hasExistingCredit, isFullyReceived, onRaiseCreditRequest, onCancelCreditRequest }) => {
	const [modalTitle, setModalTitle] = React.useState("");
	const [modalMessage, setModalMessage] = React.useState("");
	const [modalButtonText, setModalButtonText] = React.useState("");

	useEffect(() => {
		if (isFullyReceived) {
			setModalTitle("Clear credit request and receive?");
			setModalMessage(
				"All items are fully received. Upon confirming below, you will be taken to the credit request page to clear the credit request for the previously outstanding items."
			);
			setModalButtonText("Finalise and clear credit request");
		} else if (hasExistingCredit) {
			setModalTitle("Update credit request and receive?");
			setModalMessage(
				"Still not all items are fully received. Upon confirming below, you will be taken to the credit request page to update a credit request for the outstanding items."
			);
			setModalButtonText("Finalise and update credit request");
		} else {
			setModalTitle("Raise credit request and receive?");
			setModalMessage(
				"Not all items are fully received. Upon confirming below, you will be taken to the credit request page to create a credit request for the outstanding items."
			);
			setModalButtonText("Raise credit request");
		}
	}, [isFullyReceived, hasExistingCredit]);

	return (
		<ModalBase
			title={modalTitle}
			alertType={alertTypeEnum.WARNING}
			primaryButtonName={modalButtonText}
			secondaryButtonName="Go back"
			onPrimaryButtonClick={onRaiseCreditRequest}
			onSecondaryButtonClick={onCancelCreditRequest}
			onClose={onCancelCreditRequest}
			isOpen={isOpen}
			size={modalSize.FULLSCREEN}
			children={
				<Grid container spacing={3} justifyContent="center">
					<Grid size="grow">
						<Grid container size={12}>
							<Grid size={2}>
								<ErrorIcon fontSize="large" />
							</Grid>
							<Grid size={10}>
								<Grid container size={12}>
									<Grid size="grow">
										<Typography variant="body1">{modalMessage}</Typography>
										{!isFullyReceived && (
											<>
												<br />
												<Typography variant="body2">
													The receive will be finalised after the credit request is
													{hasExistingCredit ? " updated" : " raised"}
												</Typography>
											</>
										)}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			}
		/>
	);
};
